﻿"use strict";

var FindCorporateLocations = function() {

	return {

        init: function () {
            var cdnvalue = $("#cdnInput").data("value");
            const getAreasByFacilityIdApi = "/api/corporatelocations/office/getall";
            const getAreaByAreaIdApi = "/api/corporatelocations/office/get";

            const facilitiesSelect = document.querySelector("[data-facilities]");
            const areasSelect = document.querySelector("[data-areas]");
            const resetButton = document.querySelector("[data-resetbutton]");
            const officePlaceholder = document.getElementById("officePlaceholder");
            const ajaxOutput = document.getElementById("ajaxOutput");

            const seeOnMapsLabel = officePlaceholder.dataset.seeOnMapsLabel;

            const areasDefaultSelectText = areasSelect.dataset.areaSelectLabel;

            function reset() {
                areasSelect.options.length = 0;
                areasSelect.setAttribute("disabled", "disabled");
                const option = document.createElement("option");
                option.text = areasDefaultSelectText !== "" ? areasDefaultSelectText : "Select";
                option.value = "";
                areasSelect.add(option);

                facilitiesSelect.selectedIndex = 0;

                officePlaceholder.classList.remove("active");
                ajaxOutput.innerHTML = "";

            }

            function populateAreas(areas) {
                areasSelect.options.length = 0;
                var option = document.createElement("option");
                option.text = areasDefaultSelectText !== "" ? areasDefaultSelectText : "Select";

                option.setAttribute("disabled", "disabled");
                option.setAttribute("selected", "selected");

                option.value = "";
                areasSelect.add(option);

                areas.AreaOffices.forEach(function (area) {
                    option = document.createElement("option");
                    option.text = area.AreaName;
                    option.value = area.Id;
                    areasSelect.add(option);
                });

                areasSelect.removeAttribute("disabled");
            }

            function renderSelectedOffice(area) {

                let output = "";

                output += `<div class="service-card__info">`;

                //if (area.AreaOffice.AreaName) {
                //	output += `<p class="office__name">${area.AreaOffice.AreaName}</p>`;
                //}


                if (area.AreaOffice.OfficeName) {
                    output += `<p class="office__name">${area.AreaOffice.OfficeName}</p>`;
                }

                if (area.AreaOffice.OfficeAddress) {
                    output += `<div class="service-card__link">

						<svg focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16"><use xlink:href="${cdnvalue}/dist/svgsprite/icons.svg#Pin_16x16"></use></svg>

						<span>${area.AreaOffice.OfficeAddress.replace(/(\n)+/g, "<br>")}`;

                    if (seeOnMapsLabel !== "" && area.AreaOffice.OfficeAddressOnGoogleMaps && area.AreaOffice.OfficeAddressOnGoogleMaps.length > 0) {

                        var uri = encodeURIComponent(area.AreaOffice.OfficeAddressOnGoogleMaps);
                        output += ` - <a href="https://www.google.com/maps/place/${uri}" target="_blank" rel="noopener"  onclick="shvenergy.tracking.trackEvent('Find Corporate Locations', 'Googlemaps-click', '${area.AreaOffice.OfficeName}');">${seeOnMapsLabel}</a>`;
                    }



                    output += `</span></div>`;
                }

                if (area.AreaOffice.PhoneNumber) {
                    output += `<a class="service-card__link service-card__link--phone" href="tel:${area.AreaOffice.PhoneNumber}" onclick="shvenergy.tracking.trackEvent('Find Corporate Locations', 'PhoneNumber-click', '${area.AreaOffice.PhoneNumber}');">
					<svg focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16"><use xlink:href="${cdnvalue}/dist/svgsprite/icons.svg#Phone-upright_16x16"></use></svg>
					${area.AreaOffice.PhoneNumber}
				</a>`;
                }

                if (area.AreaOffice.MobileNumber) {
                    output += `<a class="service-card__link service-card__link--phone" href="tel:${area.AreaOffice.MobileNumber}" onclick="shvenergy.tracking.trackEvent('Find Corporate Locations', 'MobileNumber-click', '${area.AreaOffice.MobileNumber}');">
					<svg focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16"><use xlink:href="${cdnvalue}/dist/svgsprite/icons.svg#Phone_16x16"></use></svg>
					${area.AreaOffice.MobileNumber}
				</a>`;
                }
                
                if (area.AreaOffice.FaxNumber) {
                    output += `<div class="service-card__link">
					<svg focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16"><use xlink:href="${cdnvalue}/dist/svgsprite/icons.svg#Fax_16x16"></use></svg>
					${area.AreaOffice.FaxNumber}
				</div>`;
                }

                output += `</div>`;

                ajaxOutput.innerHTML = output;

                officePlaceholder.classList.add("active");

                if (window.matchMedia("(max-width: 639px)").matches) {
                    const element = document.getElementById("officePlaceholder");
                    const rect = element.getBoundingClientRect();
                    const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;

                    if (isSmoothScrollSupported) {
                        window.scrollTo({
                            left: 0,
                            top: rect.top + window.pageYOffset - 60,
                            behavior: 'smooth'
                        });
                    } else {
                        window.scrollTo(0, rect.top + window.pageYOffset - 60);
                    }
                }

            }

            function ajax(url, callback) {
                $.get({
                    url: url,
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");
                    }
                })
                    .done(function (response) {
                        callback(response);
                    })
                    .fail(function (textStatus) {
                        console.warn("Error!");
                        console.log(`Request failed: ${textStatus}`);
                    })
                    .always(function () {
                        //console.log("AJAX call complete!");
                    });
            }

            function getAreasByFacilityId() {
                const selectedFacilityId = facilitiesSelect.options[facilitiesSelect.selectedIndex].value;
                ajax(`${getAreasByFacilityIdApi}?id=${selectedFacilityId}`, populateAreas);
            }

            function getAreaByAreaId() {
                const selectedAreaId = areasSelect.options[areasSelect.selectedIndex].value;
                ajax(`${getAreaByAreaIdApi}?id=${selectedAreaId}`, renderSelectedOffice);
            }
			
			facilitiesSelect.addEventListener("change", getAreasByFacilityId);
			areasSelect.addEventListener("change", getAreaByAreaId);
			resetButton.addEventListener("click", reset);

			console.log("Find Corporate Locations initialized.");
		}

	};
};

document.addEventListener("DOMContentLoaded", function () {
	const findCorporateLocations = new FindCorporateLocations();
	findCorporateLocations.init();
});